import axios from "axios";
import {
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElNotification,
} from "element-plus";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { blobValidate, tansParams } from "@/utils/sunrise.js";
import cache from "@/plugins/cache";
import { saveAs } from "file-saver";
import useUserStore from "@/store/modules/user";
const HOST = window.location.protocol + "//" + window.location.host;
//网络请求Api
const API_HOST = () => {
  switch (process.env.VUE_APP_CURENV) {
    case "production":
      return HOST + process.env.VUE_APP_BASE_API;
    case "development":
      return HOST + process.env.VUE_APP_BASE_API;
    default:
      return HOST;
  }
};
// 导入qs包
import queryString from "query-string";
let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: API_HOST(),
  // 超时
  timeout: 30000,
});

let loading;
let setTime;
const closeLoading = () => {
  if (setTime) {
    clearTimeout(setTime);
    setTime = null;
  }
  setTime = setTimeout(() => {
    loading?.close();
    loading = null;
  }, 500);
};

// request拦截器
// request拦截器
service.interceptors.request.use(
  (config) => {
    !loading &&
      (loading = ElLoading.service({
        lock: true,
        text: "正在加载中，请稍等！",
        background: "rgba(0, 0, 0, 0.7)",
      }));

    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getToken() && !isToken) {
      config.headers["accessToken"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      console.log(url);
      config.params = {};
      config.url = url;
    }
    if (
      !isRepeatSubmit &&
      (config.method === "post" || config.method === "put")
    ) {
      // console.log(queryString.stringify(config.data))
      const requestObj = {
        url: config.url,
        // data: typeof config.data === "object" ? JSON.stringify(config.data) : config.data,
        // data: typeof config.data === "object" ? queryString.stringify(config.data) : config.data,
        time: new Date().getTime(),
      };

      // 格式改成urlencoded方式
      if (config.headers["content-type"] != "multipar/form-data") {
        config.headers["content-type"] =
          "application/x-www-form-urlencoded;charset=utf-8";
        config.data = queryString.stringify(config.data);
      }

      const sessionObj = cache.session.getJSON("sessionObj");
      if (
        sessionObj === undefined ||
        sessionObj === null ||
        sessionObj === ""
      ) {
        cache.session.setJSON("sessionObj", requestObj);
      }
      //  else {
      //   const s_url = sessionObj.url; // 请求地址
      //   const s_data = sessionObj.data; // 请求数据
      //   const s_time = sessionObj.time; // 请求时间
      //   const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
      //   if (
      //     s_data === requestObj.data &&
      //     requestObj.time - s_time < interval &&
      //     s_url === requestObj.url
      //   ) {
      //     const message = "数据正在处理，请勿重复提交";
      //     console.warn(`[${s_url}]: ` + message);
      //     return Promise.reject(new Error(message));
      //   } else {
      //     cache.session.setJSON("sessionObj", requestObj);
      //   }
      // }
    }
    return config;
  },
  (error) => {
    console.log(error);
    closeLoading();
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || "success";
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    closeLoading();
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data;
    }

    if (code === "denied") {
      if (res.config.url === '/userInfo/login') {
          ElMessage({
              message: msg,
              type: "error",
          });
          return Promise.reject(new Error(msg));
      }
      if (!isRelogin.show) {
        isRelogin.show = true;
        ElMessageBox.confirm(
          "登录状态已过期，您可以继续留在该页面，或者重新登录",
          "系统提示",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          useUserStore()
            .logOut()
            .then(() => {
              localStorage.removeItem("userInfo");

              location.href = location.origin + location.pathname;
            });
        });
        isRelogin.show = false;
      }
      return Promise.reject("无效的会话，或者会话已过期，请重新登录。");
    } else if (code === 500) {
      ElMessage({
        message: msg,
        type: "error",
      });
      return Promise.reject(new Error(msg));
    } else if (code !== "success") {
      ElNotification.error({
        title: msg,
      });
      return Promise.reject("error");
    } else {
      return Promise.resolve(res.data);
    }
  },
  (error) => {
    console.log("err" + error);
    closeLoading();
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    ElMessage({
      message: message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

// 通用下载方法
export function download(url, params, filename) {
  downloadLoadingInstance = ElLoading.service({
    text: "正在下载数据，请稍候",
    background: "rgba(0, 0, 0, 0.7)",
  });
  return service
    .post(url, params, {
      transformRequest: [
        (params) => {
          return tansParams(params);
        },
      ],
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      responseType: "blob",
    })
    .then(async (data) => {
      const isLogin = await blobValidate(data);
      if (isLogin) {
        const blob = new Blob([data]);
        saveAs(blob, filename);
      } else {
        const resText = await data.text();
        const rspObj = JSON.parse(resText);
        const errMsg =
          errorCode[rspObj.code] || rspObj.msg || errorCode["default"];
        ElMessage.error(errMsg);
      }
      downloadLoadingInstance.close();
    })
    .catch((r) => {
      console.error(r);
      ElMessage.error("下载文件出现错误，请联系管理员！");
      downloadLoadingInstance.close();
    });
}

export default service;
const FILTER_URL = () => {
  return API_HOST() + "/storage";
};
export { API_HOST, FILTER_URL };
